<template>
  	<div class="container wc-container wc-container-720">
			<div class="page-settings">

				<div class="settings-item">
					<h4 class="settings-item--label">Event Password</h4>
					<i-switch v-model="settings.eventPasswordEnabled" />

					<div class="additional-field" v-if="settings.eventPasswordEnabled">
						<Input v-model="settings.eventPassword"  type="text"/>
					</div>
				</div>

        <div class="settings-item">
					<h4 class="settings-item--label">IP White Listing</h4>
					<i-switch v-model="settings.ipWhiteListEnabled" />

					<div class="additional-field"  v-if="settings.ipWhiteListEnabled">
						<p>Please add comma seperated list of IP address that you want to whitelist</p>
						<Input v-model="settings.ipWhiteList" type="textarea" />
					</div>
				</div>

        <div class="settings-item">
					<h4 class="settings-item--label">Email Domain White Listing</h4>
					<i-switch v-model="settings.emailDomainWhiteListEnabled" />

					<div class="additional-field" v-if="settings.emailDomainWhiteListEnabled">
						<p>Please add comma seperated list of email domainsthat you want to whitelist</p>
						<Input v-model="settings.emailDomainWhiteList"  type="textarea"/>
					</div>
				</div>

        <div class="settings-item">
					<h4 class="settings-item--label">Referrer White Listing</h4>
					<i-switch v-model="settings.referrerDomainWhiteListEnabled"/>

					<div class="additional-field" v-if="settings.referrerDomainWhiteListEnabled" >
						<Input v-model="settings.referrerDomainWhiteList" type="textarea" />
					</div>
				</div>

				<div class="settings-item">
					<h4 class="settings-item--label">Email Validation</h4>
					<i-switch v-model="settings.emailValidationEnabled"/>
				</div>
				<div class="settings-item">
					<Button type="primary" @click="onUpdatePageSettings()" style="float:right;" v-if="!isSaving">Save</Button>
					<Button type="primary" style="float:right;" disable v-if="isSaving">Please wait</Button>
				</div>

			</div>

			</div>
  	</div>

</template>

<script>
import {
	  mapActions, mapGetters
	} from 'vuex';

	import $config from '@/config'

	export default {
		data () {
			return {
				isSaving: false,
				settings: {
					webcastId: null,
					eventPasswordEnabled: false,
					eventPassword: '',
					ipWhiteListEnabled: false,
					ipWhiteList: '',
					emailDomainWhiteListEnabled: false,
					emailDomainWhiteList: '',
					referrerDomainWhiteListEnabled: false,
					referrerDomainWhiteList: '',
				}
			}
		},
		computed: {
			...mapGetters('webcast', {
				webcast: 'getCopy'
			}),
			...mapGetters('page-settings', {
				pageSettings: 'getCopy',
			}),
    	uploadServer () {
    	  return `//${$config.uploadServer}`
    	}
  	},

  	methods: {
  		...mapActions('page-settings', {
				updatePageSettings: 'patch',
				createPageSettings: 'create',
				getPageSettings: 'find'
			}),

    	onUpdatePageSettings () {
				this.$data.isSaving = true;
    		if (!this.settings.eventPasswordEnabled) {
    			this.settings.eventPassword = ''
    		}

    		this.updatePageSettings([this.pageSettings._id, this.settings, {}])
    		.then(res => {
					this.$Message.success('Page settings has been updated');
					this.$data.isSaving = false;
    		})
    		.catch(err => {
					this.$Message.error('Error on page settings update');
					this.$data.isSaving = false;
				})
    	},

    	setExistingSettings (data) {
    		this.settings = _.cloneDeep(data)
    	},

  		handleUpload (res, file) {
      	this.$set(this.settings, 'logoUrl', res)
    	}
		},
		created () {
			this.settings.webcastId = this.webcast._id;

			this.getPageSettings({query: {	
				webcastId: this.webcast._id
			}}).then((response) => {
				if (response.data.length <= 0) {
					this.createPageSettings(this.settings).then((resp)=> {
						this.$store.commit('page-settings/setCurrent', resp._id)
					})
				} else {
					this.$store.commit('page-settings/setCurrent', response.data[0]._id)
					this.setExistingSettings(response.data[0])

					console.log('res created', response)
				}
			})
		}
	}
</script>

<style lang="scss" scoped>
	.settings {
		&-item {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 30px 0;
			&:not(:last-of-type) {
				border-bottom: 0.5px solid #e9eaec;
			}
		}

		&-text {
			width: 100%;
			color: #abacaf;
		}
	}

	.logo {
		display: block;
		width: 120px;
		height: 36px;
		margin-bottom: 20px;
		object-fit: cover;
	}

	.upload {
		&-wrapper {
			width: 100%;
		}

		&-area {
			padding: 20px 0;
		}
	}

	.additional-field {
		width: 100%;
		margin-top: 30px;
	}

</style>
